import React, { memo } from "react";
import { Row, Col, Form } from "react-bootstrap";
import PropTypes from "prop-types";

const CustomPagination = memo(
  ({
    currentPage = 1,
    totalPages = 1,
    setCurrentPage,
    onPageChange,
    manualPageControl = false,
  }) => {
    const goToPage = (page) => {
      if (page >= 1 && page <= totalPages && Number.isInteger(page)) {
        if (manualPageControl && typeof onPageChange === "function") {
          onPageChange(page);
        } else if (typeof setCurrentPage === "function") {
          setCurrentPage(page);
        }
      }
    };

    return (
      <div className="pagination justify-content-end mb-3">
        <button
          className="rounded mx-3"
          onClick={() => goToPage(currentPage - 1)}
          disabled={currentPage <= 1}
        >
          {"<"}
        </button>
        <span className="align-self-center">
          {`${Math.max(1, currentPage)} / ${Math.max(1, totalPages)}`}
        </span>
        <button
          className="rounded mx-3"
          onClick={() => goToPage(currentPage + 1)}
          disabled={currentPage >= totalPages}
        >
          {">"}
        </button>
      </div>
    );
  },
);

CustomPagination.propTypes = {
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  setCurrentPage: PropTypes.func,
  onPageChange: PropTypes.func,
  manualPageControl: PropTypes.bool,
};

const formatDate = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "-";
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = String(date.getFullYear()).slice(-2);
  return `${day}/${month}/${year}`;
};

const Entries = ({ options = [], onChange }) => {
  return (
    <Row className="align-items-center mb-3 px-2">
      <Col xs="auto" className="d-flex align-items-center gap-2">
        <span>Show</span>
        <Form.Select
          style={{ width: "80px" }}
          onChange={(e) => onChange(e.target.value)}
        >
          {options.map((opt, i) => (
            <option key={i}>{opt}</option>
          ))}
        </Form.Select>
        <span>entries</span>
      </Col>
    </Row>
  );
};

export { CustomPagination, formatDate, Entries };
